import { render, staticRenderFns } from "./ticketList.vue?vue&type=template&id=3b13c7c7&scoped=true"
import script from "./ticketList.vue?vue&type=script&lang=js"
export * from "./ticketList.vue?vue&type=script&lang=js"
import style0 from "./ticketList.vue?vue&type=style&index=0&id=3b13c7c7&prod&lang=scss&scoped=true"
import style1 from "./ticketList.vue?vue&type=style&index=1&id=3b13c7c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13c7c7",
  null
  
)

export default component.exports